export type IntegrationType =
  "THREESHAPE" | "MEDITLINK" | "SHINING3D" | "DSCORE";

export const IntegrationTypeEnum: Record<IntegrationType, IntegrationType> = {
  THREESHAPE: "THREESHAPE",
  MEDITLINK: "MEDITLINK",
  SHINING3D: "SHINING3D",
  DSCORE: "DSCORE",
};
